import axios from "axios";

const keywordIdeas = {
  namespaced: true,
  state: {
    keywords: {}
  },
  mutations: {
    async setKeywords(state, data){
      state.keywords = data;
    }
  },
  actions: {
    fetchData: ({commit}) => axios.get('/ajax/keywords/get-ranking-positions')
      .then((response) => commit('setKeywords', response.data)),
    refreshKeywordRanking: (state, id) => axios.get(`/ajax/keywords/refresh/${id}`),
  }
};

export default keywordIdeas;
